import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/** Al cambiar de página, empezamos arriba (o en el ancla indicada). */
export const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.slice(1);
      const tryScroll = (attempt = 0) => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth' });
        } else if (attempt < 10) {
          setTimeout(() => tryScroll(attempt + 1), 120);
        }
      };
      tryScroll();
      return;
    }
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [pathname, hash]);

  return null;
};
